import script from "./TransferRegistPage.vue?vue&type=script&setup=true&lang=js"
export * from "./TransferRegistPage.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__